<template>
  <div class="activity-wrap">
    <app-header />
    <div class="banner_main">
      <div class="content_box">
        <img
          src="../../assets/images/activity/activityforecast2024/toptemTiele.png"
        />
      </div>
    </div>
    <div class="content_main">
      <div class="main_box first_box">
        <div class="header_main">
          <p>十大牛股</p>
          <p>SHIDANIUGU</p>
        </div>
        <div class="text_box">
          数据显示，剔除年内上市新股，2023年十大牛股年涨幅的上榜门槛达到452.83%。<br />
          2023年十大牛股分别为联特科技、鸿博股份、凯华材料、剑桥科技、佰维存储、中际旭创、捷荣技术、中航电测、圣龙股份、万兴科技。其中，联特科技以年最大涨幅807%勇夺年内股王称号。<br />
          今年牛股阵营大多聚集于上半年的人工智能板块和下半年的华为概念。
        </div>
        <div class="table_main_box">
          <table cellspacing="0" cellpadding="0">
            <tr>
              <th width="143">序号</th>
              <th width="143">证券代码</th>
              <th width="143">证券简称</th>
              <th width="143">年最大涨幅</th>
              <th>概念题材</th>
            </tr>
            <tr class="td_box" v-for="(item, index) in topList" :key="item.stock">
              <td>{{ index + 1 }}</td>
              <td>{{ item.stock }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zf + "%" }}</td>
              <td>{{ item.gntc }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="main_box">
        <div class="header_main">
          <p>十大熊股</p>
          <p>SHIDAXIONGGU</p>
        </div>
        <div class="text_box">
          数据显示，剔除年内上市新股，2023年十大熊股分别为海优新材、德新科技、金刚光伏、利元亨、昱能科技、派能科技、德业股份、明冠新材、广联达、禾迈股份，跌幅均超60%。<br />
          新能源，茅指数，白马股成为今年跌幅最大的方向，基金抱团加速瓦解，成为下跌重灾区。
        </div>
        <div class="table_main_box">
          <table cellspacing="0" cellpadding="0">
            <tr>
              <th width="143">序号</th>
              <th width="143">证券代码</th>
              <th width="143">证券简称</th>
              <th width="143">年最大跌幅</th>
              <th>概念题材</th>
            </tr>
            <tr
              v-for="(item, index) in fallList"
              :key="item.stock"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.stock }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zf + "%" }}</td>
              <td>{{ item.gntc }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
		<p class="footer_box">投资有风险，入市需谨慎</p>
  </div>
</template>
  <script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
      topList: [
        { stock: "301205", name: "联特科技", zf: "807.07", gntc: "CPO" },
        { stock: "831526", name: "凯华材料", zf: "631.44", gntc: "电子元器件封装材料" },
        { stock: "002229", name: "鸿博股份", zf: "590.40", gntc: "人工智能、算力" },
        { stock: "603083", name: "剑桥科技", zf: "567.97", gntc: "CPO" },
        { stock: "688525", name: "佰维存储", zf: "553.99", gntc: "存储器" },
        { stock: "300308", name: "中际旭创", zf: "533.52", gntc: "CPO" },
        { stock: "002855", name: "捷荣技术", zf: "512.06", gntc: "华为概念" },
        { stock: "300114", name: "中航电测", zf: "504.46", gntc: "并购重组" },
        { stock: "603178", name: "圣龙股份", zf: "488.68", gntc: "华为概念" },
        { stock: "300624", name: "万兴科技", zf: "452.83", gntc: "人工智能" },
      ],
      fallList: [
        { stock: "688680", name: "海优新材", zf: "76.95", gntc: "光伏" },
        { stock: "688348", name: "昱能科技", zf: "74.66", gntc: "光伏" },
        { stock: "603032", name: "德新科技", zf: "74.17", gntc: "锂电池" },
        { stock: "688499", name: "利元亨",  zf: "73.74", gntc: "锂电池" },
        { stock: "688063", name: "派能科技", zf: "71.46", gntc: "锂电池" },
        { stock: "605117", name: "德业股份", zf: "71.33", gntc: "光伏" },
        { stock: "688560", name: "明冠新材", zf: "70.79", gntc: "光伏" },
        { stock: "300093", name: "金刚光伏", zf: "70.08", gntc: "光伏" },
        { stock: "002410", name: "广联达", zf: "70.04", gntc: "基金重仓" },
        { stock: "688032", name: "禾迈股份", zf: "69.29", gntc: "光伏" },
      ],
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {},
  methods: {},
};
</script>
  <style lang="scss" scoped>
// 清除浮动
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.activity-wrap {
  background: #ededed;
  overflow: hidden;
  overflow: hidden;
  .banner_main {
    width: 100%;
    height: 220px;
    margin-bottom: 22px;
    background: url("../../assets/images/activity/activityforecast2024/toptenBanner.png") no-repeat;
    background-size: 100% 100%;
    .content_box {
      width: 900px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
      padding-top: 68px;
      box-sizing: border-box;
      img {
        width: 607px;
        height: 70px;
      }
    }
  }
  .content_main {
    width: 900px;
    margin: 0 auto;
    background-color: #fff;
    padding: 0 20px 37px;
    box-sizing: border-box;
    .main_box {
      width: 100%;
      &.first_box {
        margin-bottom: 14px;
        .table_main_box {
					table{
						.td_box {
							td {
								&:nth-child(4) {
									color: rgba(204, 18, 18, 1) !important;
								}
							}
          }
					}
          
        }
      }
      .header_main {
        width: 100%;
        height: 106px;
        border-bottom: 2px solid rgba(237, 237, 237, 1);
        padding-top: 32px;
        text-align: center;
        p {
          &:first-child {
            font-size: 37px;
            color: rgba(54, 54, 54, 1);
          }
          &:last-child {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 22px;
            letter-spacing: 0px;
            color: rgba(54, 54, 54, 0.3);
          }
        }
      }
      .text_box {
        font-size: 18px;
        line-height: 36px;
        letter-spacing: 0px;
        color: rgba(119, 119, 119, 1);
        padding: 23px 0 29px 0;
        box-sizing: border-box;
      }
      .table_main_box {
        width: 100%;
        table {
          width: 100%;
          border: 1px solid rgba(246, 223, 133, 1);
          th {
            height: 62px;
            background-color: rgba(254, 225, 110, 1);
            line-height: 62px;
            font-size: 20px;
            color: rgba(85, 85, 85, 1);
          }
          td {
            height: 42px;
            list-style: 42px;
            font-size: 18px;
            font-size: 18px;
            border-bottom: 1px solid rgba(246, 223, 133, 1);
            text-align: center;
						&:nth-child(4) {
							color: rgba(27, 185, 53, 1) !important;
						}
          }
        }
      }
    }
  }
	.footer_box{
		margin: 27px 0;
		text-align: center;
		font-size: 12px;
		color: rgba(85, 85, 85, .3);
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activityTopTen2023.vue